<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hnotas">
            <div class="textHeader flx">
                <div class="dUno dtMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>CUIDA TU SALUD</h1>
                    <p>Ponemos a su disposición información de interés que le ayudará a saber más acerca de enfermedades y acciones relacionadas a cuidar su salud y la de su familia.</p>
                    <div style="margin:15px auto auto auto;"><button type="button" class="btn" (click)="getAll()">VER TODAS LAS NOTAS</button></div>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>

    <div class="Fnota">
        <div class="dDoce dmOnce FnotaInt">
            <div class="FnotaTitular">
                <div class="FnotaImgPrincipal">
                    <picture>
                        <source type="image/webp" srcset="{{nota?.urlimagenWebp}}">
                        <source type="image/jpg" srcset="{{nota?.urlimagen}}">
                        <img src="{{nota?.img}}" class="imgnotahead" alt="{{nota?.titulo}}" style="padding: 0 !important;">
                    </picture>
                </div>
                 <div class="FnotaTitle dSeis dtDoce dmDoce">
                    <h1>{{nota?.titulo}}</h1>
                </div>
            </div>
            <div class="FnotaTextoPrincipal dOcho dtNueve dmDoce">
                <div class="dDoce" [innerHTML]="contenido"></div>
            </div>
        </div>
        <div class="dOcho dtNueve dmDoce FredesCompartir flx">
            <div class="flx">
                Compartir esta nota: &nbsp;
                <div [socialShare]="'fb'"> <img src="./assets/images/facebook-logo.png" alt="Redes sociales" class="socialMedia"></div>
                <div [socialShare]="'tw'">  <img src="./assets/images/twitter-logo.png" alt="Redes sociales" class="socialMedia"></div>
            </div>
        </div>

        <section class="Fnoti dDiez dtOnce dmDoce flx mt-3">
            <h3 class="dDoce">CUIDA TU SALUD</h3>
            <div class="dCuatro Fnota" id="FnotiInt" *ngFor="let nota of notas;" >
                <a  [routerLink]="'/nota/' + nota.url " class="notalnk">
                <div class="FnotiImg">
                    <img src="{{nota?.urlimagen}}" alt="{{nota?.titulo}}" />
                </div>
                <div class="FnotaTexto">
                    <h4 innerHtml="{{nota?.titulo}}"></h4>
                    <hr />
                    <p innerHtml="{{nota?.intro}}"></p>
                </div>
            </a>
            </div>
        </section>

    </div>
</div>